// extracted by mini-css-extract-plugin
module.exports = {"main":"SingleShop_main__2yRp6","gradient":"SingleShop_gradient__5JNUK","mydata":"SingleShop_mydata__1nJC_","submain":"SingleShop_submain__3AUzR"};